import * as environment from '../../../config/environment';

import { BaseAPI } from "../../BaseAPI";


class IsyeriSinifiAPI extends BaseAPI {
  

  constructor () {
    const baseUrl = environment.API_URL + "IsyeriSinifiListe";
    super(baseUrl);
  }


  getIsyeriSinifiListe( request?: any){

    return this.get("",request);
  }

}
export default new IsyeriSinifiAPI();
class IsyeriSinifiRequest {
  public IsyeriSinifiKodu?: number;

  constructor( kullanimSekliKodu?: number) {
   
        this.IsyeriSinifiKodu = kullanimSekliKodu;

  }
}
export { IsyeriSinifiRequest };